module.exports = __webpack_public_path__ + "img/P35.3670681f.png";